export default __webpack_public_path__ + "static/media/open-logo.c6864985.svg";